import { useState } from "react";
import { getSlotTemplateRange } from "../utils/scheduleTimeUtils";

export default function useScheduleModals({
  findBestOpenRange,
  getAssignments,
  getUnitText,
  isAmbulanceSlot,
  roleMetaByDate,
}) {
  const [assignModal, setAssignModal] = useState(null);
  const [assignSearch, setAssignSearch] = useState("");

  const [ambulanceModal, setAmbulanceModal] = useState(null);

  const [detailsModal, setDetailsModal] = useState(null);
  const [addPositionModal, setAddPositionModal] = useState(null);

  function openAssignModalForSlot({
    iso,
    roleKey,
    roleLabel,
    blockTitle,
    publishedPosition = "",
  }) {
    if (isAmbulanceSlot(roleLabel)) return;

    const range = getSlotTemplateRange(roleLabel);
    const proposed = findBestOpenRange(
      getAssignments(iso, roleKey),
      range.start,
      range.end
    );

    const meta = roleMetaByDate?.[iso]?.get(roleKey);

    setAssignSearch("");
    setAssignModal({
      iso,
      roleKey,
      roleLabel,
      blockTitle,
      start: proposed.start,
      end: proposed.end,
      publishedPosition,
      isExtraSlot: !!meta?.isExtraSlot,
    });
  }

  function openAssignModalForPublishedShift(shift, blockTitle = "") {
    if (!shift) return;

    const meta = roleMetaByDate?.[shift.iso]?.get(shift.roleKey);

    setAssignSearch("");
    setAssignModal({
      iso: shift.iso,
      roleKey: shift.roleKey,
      roleLabel: shift.roleLabel,
      blockTitle,
      start: shift.start,
      end: shift.end,
      publishedPosition: shift.position || "",
      isExtraSlot: !!meta?.isExtraSlot,
    });
  }

  function openAmbulanceModal({ iso, roleKey, roleLabel, blockTitle }) {
    setAmbulanceModal({
      iso,
      roleKey,
      roleLabel,
      blockTitle,
      value: getUnitText(iso, roleKey),
    });
  }

  function openSlotInteraction({
    iso,
    roleKey,
    roleLabel,
    blockTitle,
    publishedPosition = "",
  }) {
    if (isAmbulanceSlot(roleLabel)) {
      openAmbulanceModal({ iso, roleKey, roleLabel, blockTitle });
      return;
    }

    openAssignModalForSlot({
      iso,
      roleKey,
      roleLabel,
      blockTitle,
      publishedPosition,
    });
  }

  return {
    assignModal,
    setAssignModal,
    assignSearch,
    setAssignSearch,
    ambulanceModal,
    setAmbulanceModal,
    detailsModal,
    setDetailsModal,
    addPositionModal,
    setAddPositionModal,
    openAssignModalForSlot,
    openAssignModalForPublishedShift,
    openAmbulanceModal,
    openSlotInteraction,
  };
}